/******************************************************************************
 *
 * Copyright (c) 2017, the Perspective Authors.
 *
 * This file is part of the Perspective library, distributed under the terms of
 * the Apache License 2.0.  The full license can be found in the LICENSE file.
 *
 */

import { select } from "d3";

export const labelVisible = (d) =>
    d.y1 <= 3 && d.y0 >= 1 && (d.y1 - d.y0) * (d.x1 - d.x0) > 0.06;

export function labelTransform(d, radius) {
    const x = (((d.x0 + d.x1) / 2) * 180) / Math.PI;
    const y = ((d.y0 - 1 + (d.y1 - 1)) / 2) * radius;
    return `rotate(${x - 90}) translate(${y},0) rotate(${x < 180 ? 0 : 180})`;
}

export function cropLabel(d, targetWidth) {
    let actualWidth = this.getBBox().width;
    if (actualWidth > targetWidth) {
        let labelText = d.label;
        const textSelection = select(this);
        while (actualWidth > targetWidth) {
            labelText = labelText.substring(0, labelText.length - 1);
            textSelection.text(() => labelText);
            actualWidth = this.getBBox().width;
        }
        textSelection.text(
            () =>
                `${labelText
                    .substring(0, labelText.length - 3)
                    .replace(/\s+$/, "")}...`
        );
    }
}
